module.exports = __webpack_public_path__ + "static/media/mslogo.ca49d99c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mslogo.png
// module id = 384
// module chunks = 0